import * as React from "react";
import {FormComponentProps} from "../../form/Form";
import {TicketView} from "./TicketView";
import {CreateTicketModal} from "./CreateTicketModal";
import {LinkTicketModal} from "./LinkTicketModal";
import {ItemView, Ticket, TicketTournaments, TournamentRef} from "../../../../generated/protocol";

interface SatelliteTicketsPanelProps extends FormComponentProps {
    model: string,
    label: string,
    singleTicket?: boolean,
    linkOnly?: boolean
}

interface SatelliteTicketsPanelState {
    createTicketModalIsOpen?: boolean,
    linkTicketModalIsOpen?: boolean
}

type LinkTicket = Ticket & TicketTournaments;

export class SatelliteTicketsPanel extends React.Component<SatelliteTicketsPanelProps, SatelliteTicketsPanelState> {

    public static defaultProps: Partial<SatelliteTicketsPanelProps> = {
        singleTicket: false
    };


    constructor() {
        super();

        this.state = {
            createTicketModalIsOpen: false,
            linkTicketModalIsOpen: false
        };
    }

    componentDidMount() {
    }

    modelName() {
        return this.props.model;
    }

    getModel() {
        return this.props.fieldSet.getModelValue(this.modelName());
    }

    deleteTicket(entity: any) {
        console.log("delete ticket", entity);
        let tickets: any[] = this.getModel();
        let filteredTickets: any[] = tickets.filter(ticket => ticket.nameId != entity.nameId);

        this.props.fieldSet.updateModel(this.modelName(), filteredTickets, false, {errorName: null, pristine: false});
    }

    openCreateTicketModal() {
        this.setState({createTicketModalIsOpen: true});
    }

    closeCreateTicketModal() {
        this.setState({createTicketModalIsOpen: false});
    }

    saveTicket(newTicket: Ticket) {
        console.log("Save Ticket: ", newTicket);
        let tickets: any[] = [];
        if (this.props.singleTicket) {
            tickets = [newTicket];
        }
        else {
            tickets = this.getModel().slice();
            // TODO : We probably need to check against duplicates.
            tickets.push(newTicket);
        }

        this.props.fieldSet.updateModel(this.modelName(), tickets, false, {errorName: null, pristine: false});
    }

    getAllKnownTicketsModel() {
        return this.props.fieldSet.getModelValue("allKnownTickets");
    }

    openLinkTicketModal() {
        this.setState({linkTicketModalIsOpen: true});
    }

    closeLinkTicketModal() {
        this.setState({linkTicketModalIsOpen: false});
    }

    linkTicket(itemView: ItemView) {
        const aTicket: LinkTicket = {
            nameId: itemView.nameId,
            name: itemView.name,

            description: itemView.description,
            image: itemView.imageUrl,

            allowMultiple: itemView.allowMultiple,

            expirationDate: itemView.expirationDate,
            expirationInterval: itemView.expirationInterval,
            expirationIntervalUnits: itemView.expirationIntervalUnit,

            satellites: itemView.extras.satellites as TournamentRef[],
            targets: itemView.extras.targets as TournamentRef[],

            coinAmount: itemView.coinAmount,
            coinType: itemView.coinType,
        };
        this.saveTicket(aTicket);
    }

    renderTickets() {
        var tickets: any[] = this.getModel();
        if (!tickets || tickets.length == 0) {
            return (<div className="no-tickets">No Tickets</div>);
        }
        else {
            if (this.props.singleTicket) {
                var ticket = tickets[0];

                return (<TicketView buttonClass={'delete-button'} key={ticket.nameId} entity={ticket}
                                    onClick={this.deleteTicket.bind(this)}/>);
            }
            else {
                return (<div>
                    {tickets.map(ticket => <TicketView buttonClass={'delete-button'} key={ticket.nameId} entity={ticket}
                                                       onClick={this.deleteTicket.bind(this)}/>)}
                </div>);
            }
        }
    }

    render() {

        return (
            <div className="satellite-tickets-panel">
                <label className="col-sm-2 control-label">{this.props.label}</label>
                <div className="col-sm-10 tickets">
                    {this.renderTickets()}
                </div>
                <div className="action-bar">
                    {!this.props.linkOnly && <button className="create-ticket-button" onClick={(event) => {
                        event.preventDefault();
                        this.openCreateTicketModal();
                    }}><i className="fa fa-plus-circle"/>Create
                    </button>}
                    <button className="link-ticket-button" onClick={(event) => {
                        event.preventDefault();
                        this.openLinkTicketModal();
                    }}><i className="fa fa-link"/>Link
                    </button>
                </div>
                <div className="bottom"/>
                <CreateTicketModal isOpen={this.state.createTicketModalIsOpen}
                                   onClose={this.closeCreateTicketModal.bind(this)}
                                   onSave={this.saveTicket.bind(this)}/>
                <LinkTicketModal isOpen={this.state.linkTicketModalIsOpen}
                                 onClose={this.closeLinkTicketModal.bind(this)} onLink={this.linkTicket.bind(this)}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/SatelliteTicketsPanel.tsx